export default function ImageCard({ title, img, alt, children }) {
  return (
    <div className="card-container">
      <div className="card">
        <div className="card-front">
          <img src={img} alt={alt} loading="lazy" decoding="async" />
          <div className="cardContent">
            <h1>{title}</h1>
          </div>
        </div>
        <div className="card-back">
          <div className="back-content">{children}</div>
        </div>
      </div>
    </div>
  );
}
